import getContentArea from './get-content';
import getAsset from './get-asset';
import sync from './get-keys';
import MarkdownComponent from './markdown.component';

let contentfulPlugin = {};
contentfulPlugin.install = function (Vue, router) {
    Vue.component('markdown', MarkdownComponent);
  };

export {
  contentfulPlugin,
  sync,
  getContentArea,
  getAsset
};
